import { WorkflowItem } from '../../store/interfaces/workflowItem';
import { TaskItemStatus } from '../../taskList/constants';
import { Language } from '../interfaces/language';
import { ValidateAssessmentLaunchConfig } from '../../assessment/interfaces';
import { AssessmentDetails } from '../../taskList/interfaces';
import { SessionStore } from '../../constants/sessionStore';
import { getCookie } from './cookies';

/** Delete launchconfig and url if already completed assessment is being launched again */
export const removeLaunchConfig = (currentWorkflowItem: WorkflowItem): void => {
  const launchConfig = sessionStorage.getItem(SessionStore.launchconfig);
  if (currentWorkflowItem.nestedItemsState && currentWorkflowItem.nestedItemsState.length && launchConfig) {
    const parsedConfig = JSON.parse(launchConfig);
    const tcPlusFlow = getCookie('TcPlusFlag') === '1';
    currentWorkflowItem.nestedItemsState.forEach((item) => {
      if (item.itemId === parsedConfig.itemId && item.status !== TaskItemStatus.IN_PROGRESS && !tcPlusFlow) {
        sessionStorage.removeItem(SessionStore.launchconfig);
        sessionStorage.removeItem(SessionStore.launchurl);
      }
    });
  }
};

export const createLaunchConfig = (
  itemId: string,
  taskId: number,
  language: Language,
  assessment: AssessmentDetails,
): ValidateAssessmentLaunchConfig => {
  return {
    activeComponentId: language.activeComponentId || assessment.activeComponentId,
    itemId: itemId,
    taskId: taskId,
    packageId: language.testId || 0, // 0 will never be passed -- need to bypass eslint
    originalPackageId: assessment.packageId,
    projectId: assessment.projectId,
    selectedLanguageCode: language.isoCode,
    sittingId: assessment.sittingId,
    displayOptions: assessment.displayOptions,
    packageTag: assessment.packageTag,
  };
};
